module.exports = __webpack_public_path__ + "static/img/about-03.15be17e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-03.jpg
// module id = jtFz
// module chunks = 0